const conversationUpdateTypes = {
  LABELLED: 'LABELLED',
  DELETED: 'DELETED',
  ACTIVITY: 'ACTIVITY',
  SUGGESTIONS: 'SUGGESTIONS'
};

export default conversationUpdateTypes;